import { Box, Grid } from "@mui/material";
import { Message, MessageSections } from "../../../components/message/message";
import { Title } from "../Title/Title";
import express from '../../../../assets/express.png';
import master from '../../../../assets/master.png';
import visa from '../../../../assets/visa.png';
import arca from '../../../../assets/arca.png';


const paymentMethods = [
    { name: "MasterCard", logo: master, alt: "MasterCard" },
    { name: "Visa", logo: visa, alt: "Visa" },
    { name: "ArCa", logo: arca, alt: "ArCa" },
    { name: "American Express", logo: express, alt: "American Express" },
];

const PaymentMethods = () => {
    return (
        <Box sx={{ padding: 4, textAlign: "center", backgroundColor: "#FFF" }}>
            <Title sx={{ marginBottom: "20px" }}>
                <Message
                    messageKey={'payment_methods'}
                    sectionId={MessageSections.MAIN}
                />
            </Title>
            <Grid container spacing={3} justifyContent="center">
                {paymentMethods.map((method, index) => (
                    <Grid item key={index}>
                        <img
                            src={method.logo}
                            alt={method.alt}
                            style={{ maxWidth: 140, height: "auto" }}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default PaymentMethods;
